import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TCutbankInState } from './cutbank-in-db.models';

export const selectCutbankInStore = createFeatureSelector<TCutbankInState>('CUTBANK_IN_STORE');

export const getSubjects = createSelector(
  selectCutbankInStore,
  (selectCutbankInStore) => selectCutbankInStore.subjects,
);

export const IsComponentBundleScanEnabled = createSelector(
  selectCutbankInStore,
  (selectCutbankInStore) => selectCutbankInStore.isComponentBundleScanEnabled,
);

export const getTransactionLogInfo = createSelector(selectCutbankInStore, (state) => state.transactionLogInfo);

export const getActivityLogInfo = createSelector(selectCutbankInStore, (state) => state.activityLogInfo);
